import React from 'react';
import { Button, Grid, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  title: {
    fontSize: theme.textFontSize,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: '8px 0px',
    flexBasis: 0,
    display: 'flex',
    justifyContent: 'space-between'
  },
  headerButton: {
    textTransform: 'uppercase',
    borderColor: theme.gridTextColor,
    color: theme.gridTextColor,
    padding: '4px 8px',
    borderRadius: 2,
    fontSize: theme.dispatchCardTextFontSize,
    marginRight: 10
  }
});

const SectionHeader = ({ classes, title, headerButtonDetails }) => {
  return (
    <Grid className={classes.title} item xs={12}>
      <span>{title}</span>
      {headerButtonDetails && (
        <Button
          onClick={headerButtonDetails.onClick}
          variant="outlined"
          className={classes.headerButton}>
          {headerButtonDetails.label}
        </Button>
      )}
    </Grid>
  );
};

export default withStyles(styles)(SectionHeader);
